import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1350,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '5901d32d-158b-400b-b813-ec0927f8955e',
      type: 'Container',
      name: 'leftTop',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: 'a658c1fb-58b2-4838-bb87-9e6d9cdb6451',
      type: 'Container',
      name: 'rightTop',
      nameSpace: '',
      className: '',
      x: 1350,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: '43792a59-236f-463f-a5ed-7fa4118e0243',
      type: 'Container',
      name: 'leftBottom',
      nameSpace: '',
      className: '',
      x: 0,
      y: 760,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      type: 'Container',
      name: 'centerBottom',
      nameSpace: '',
      className: '',
      x: 675,
      y: 760,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: 'd53ca109-e32f-4a1f-9822-28620feb9cd2',
      type: 'Container',
      name: 'centerTop',
      nameSpace: '',
      className: '',
      x: 675,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: '302e28e3-81c6-4ffb-a5ba-ff36f27210ee',
      type: 'Container',
      name: 'rightBottom',
      nameSpace: '',
      className: '',
      x: 1350,
      y: 760,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      data: ''
    },
    {
      id: '3f192a85-6bbc-45e2-8a3e-7f39084fb8d0',
      type: 'Graphics',
      name: 'overlay',
      nameSpace: '',
      className: '',
      x: 675,
      y: 380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd2274cf5-ee93-4d86-bbd7-6f5065a2080e',
      bake: false,
      commands: [
        {
          id: 'a2a073e5-16ec-4f44-a7b4-4bb9f092a6ad',
          type: 'beginFill',
          color: 0,
          alpha: 0.8
        },
        {
          id: 'a3e60d60-27d2-413d-ae85-c5b576bd83ed',
          type: 'drawRect',
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        }
      ],
      data: ''
    },
    {
      id: '7b00a104-d150-4340-a85e-f4ef1b5d4683',
      type: 'Container',
      name: 'coinBarContainer',
      nameSpace: '',
      className: '',
      x: 200,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5901d32d-158b-400b-b813-ec0927f8955e',
      data: ''
    },
    {
      id: '0e4e31da-d13c-47ab-bf30-21acbb7976b0',
      type: 'Sprite',
      name: 'settingsButton',
      nameSpace: '',
      className: '',
      x: 74,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_round_settings',
      parent: '43792a59-236f-463f-a5ed-7fa4118e0243',
      data: ''
    },
    {
      id: '44de32ea-da4f-4779-9b43-7dc7cbd5b609',
      type: 'Sprite',
      name: 'endLevelButton',
      nameSpace: '',
      className: '',
      x: -365,
      y: -59,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_small_red',
      parent: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      data: ''
    },
    {
      id: '13d936e6-927f-4aca-ab00-258632c2bfd6',
      type: 'Container',
      name: 'jokerContainer',
      nameSpace: '',
      className: '',
      x: 412,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      data: ''
    },
    {
      id: 'dfb53553-e557-4bd4-b224-1b224f26e6f6',
      type: 'Container',
      name: 'undoContainer',
      nameSpace: '',
      className: '',
      x: 195,
      y: -100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      data: ''
    },
    {
      id: 'a45acd14-5937-47de-a135-107fdcd62b9a',
      type: 'Sprite',
      name: 'extraCardsButton',
      nameSpace: '',
      className: '',
      x: -67,
      y: -96,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'buy_extra_cards_free',
      parent: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      data: ''
    },
    {
      id: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      type: 'Container',
      name: 'goldBarContainer',
      nameSpace: '',
      className: '',
      x: 297,
      y: -4,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '7bf29c5e-1bb8-4044-9979-d2c235ff3319',
      data: ''
    },
    {
      id: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      type: 'Container',
      name: 'scoreBarContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 33,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd53ca109-e32f-4a1f-9822-28620feb9cd2',
      data: ''
    },
    {
      id: '6a00832d-c342-49ac-8aaa-9e8201e2bf1a',
      type: 'Container',
      name: 'boostersContainer',
      nameSpace: '',
      className: '',
      x: -100,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '302e28e3-81c6-4ffb-a5ba-ff36f27210ee',
      data: ''
    },
    {
      id: 'e06cfcc5-3972-449b-b3fb-f09bad8f8f05',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EndLevelCaps',
      localize: true,
      maxWidth: 193,
      maxHeight: 67,
      maxFontSize: 28,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8a2831',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '44de32ea-da4f-4779-9b43-7dc7cbd5b609',
      data: ''
    },
    {
      id: 'a9c95559-94ae-435e-94bb-de7fe30a8942',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'text_bg_med_2',
      parent: '13d936e6-927f-4aca-ab00-258632c2bfd6',
      data: ''
    },
    {
      id: '20e7800e-61b5-407e-adb1-00aa7ad7aebb',
      type: 'Text',
      name: 'jokerText',
      nameSpace: '',
      className: '',
      x: 6,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3000',
      localize: false,
      maxWidth: 100,
      maxHeight: 47,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#271611',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.6,
        dropShadowBlur: 0,
        dropShadowColor: '#251705',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '13d936e6-927f-4aca-ab00-258632c2bfd6',
      data: ''
    },
    {
      id: 'd62bcc06-ac1f-4653-8563-c5c7686edadb',
      type: 'Sprite',
      name: 'jokerCoin',
      nameSpace: '',
      className: '',
      x: -58,
      y: -29,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_ingame_small',
      parent: '13d936e6-927f-4aca-ab00-258632c2bfd6',
      data: ''
    },
    {
      id: '6a409f23-3cb1-4225-9ec8-aca5b0e95e7f',
      type: 'Sprite',
      name: 'jokerButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: -120,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_joker',
      parent: '13d936e6-927f-4aca-ab00-258632c2bfd6',
      data: ''
    },
    {
      id: 'b9c29a51-334f-4413-86a4-37a993d627ec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 72,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'text_bg_short_2',
      parent: 'dfb53553-e557-4bd4-b224-1b224f26e6f6',
      data: ''
    },
    {
      id: '917b3a76-37c3-4963-965d-054042cafea3',
      type: 'Text',
      name: 'undoText',
      nameSpace: '',
      className: '',
      x: 6,
      y: 70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '240',
      localize: false,
      maxWidth: 76,
      maxHeight: 47,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#271611',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.6,
        dropShadowBlur: 0,
        dropShadowColor: '#251705',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dfb53553-e557-4bd4-b224-1b224f26e6f6',
      data: ''
    },
    {
      id: '1a34c64c-ec5b-490a-bbb3-0edcf33e51bb',
      type: 'Sprite',
      name: 'undoCoin',
      nameSpace: '',
      className: '',
      x: -50,
      y: 71,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_ingame_small',
      parent: 'dfb53553-e557-4bd4-b224-1b224f26e6f6',
      data: ''
    },
    {
      id: '57b8cd72-161d-4fd7-aed6-cc0fd658cc6d',
      type: 'Sprite',
      name: 'undoButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_round_undo',
      parent: 'dfb53553-e557-4bd4-b224-1b224f26e6f6',
      data: ''
    },
    {
      id: 'b14875f2-39eb-4c08-8c63-fefa85cfd7f8',
      type: 'Text',
      name: 'extraCardsText',
      nameSpace: '',
      className: '',
      x: -18,
      y: 61,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123',
      localize: false,
      maxWidth: 72,
      maxHeight: 49,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#271611',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.6,
        dropShadowBlur: 0,
        dropShadowColor: '#0a0539',
        dropShadowDistance: 4,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a45acd14-5937-47de-a135-107fdcd62b9a',
      data: ''
    },
    {
      id: '693e72a8-1568-4dcd-96ec-5c065f8344a7',
      type: 'Sprite',
      name: 'extraCardsCoin',
      nameSpace: '',
      className: '',
      x: -36,
      y: 61,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_ingame_small',
      parent: 'a45acd14-5937-47de-a135-107fdcd62b9a',
      data: ''
    },
    {
      id: '04a823aa-c128-4352-99d7-7ba0276208aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'streakbar_bg',
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: '37080c4a-2653-4042-9afb-85c069508636',
      type: 'Sprite',
      name: 'goldBarProgress',
      nameSpace: '',
      className: '',
      x: 0,
      y: -28,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.764398,
        y: 0.309859
      },
      angle: -90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'progress_gradient',
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: '7f06ed44-9029-4a45-bc09-9bcbd93f4b4f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'streakbar',
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: '727f23a4-5f87-42e9-b766-0aeb395ab534',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -182,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gold_cards_icon',
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: 'e6e93fee-6eca-4f3e-8619-1587e19de94f',
      type: 'Text',
      name: 'goldBarInfoText',
      nameSpace: '',
      className: '',
      x: 37,
      y: -193,
      anchor: {
        x: 0.3,
        y: 0.45
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 30,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '?',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#5c5c5c',
        strokeThickness: 3,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.3,
        dropShadowAngle: 1.3,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: '85d30993-84bd-4235-84f9-378fe43d6689',
      type: 'Text',
      name: 'goldBarText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20/20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#271611',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.6,
        dropShadowBlur: 0,
        dropShadowColor: '#251705',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '97ba5c35-06ae-4dc1-905e-f3eb58fbd35e',
      data: ''
    },
    {
      id: 'b8aca586-514c-4749-8e69-9a18c8ffea05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_score_background',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: 'bcfa4656-61af-4059-a01a-0877e8c2da55',
      type: 'Sprite',
      name: 'scoreBarProgress',
      nameSpace: '',
      className: '',
      x: -109,
      y: -18,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.136126,
        y: 0.478873
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'progress_gradient',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: '4a6ea0ac-3eb0-4180-b2d4-ead371e23e71',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_score_bar',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: 'b9d2e5bd-617a-4fad-98bc-16cb12ee1582',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'scoreBarStars',
      x: -60,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_score_bar_star',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: 'e3bc5133-df52-4978-b977-90363dcff013',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'scoreBarStars',
      x: 10,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_score_bar_star',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: '37789d7e-626d-4e4f-9f88-95fbc34c1be3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'scoreBarStars',
      x: 90,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_level_score_bar_star',
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: '8c8d84ea-877e-46c3-8bdd-9339c4a860c3',
      type: 'Text',
      name: 'scoreDevText',
      nameSpace: '',
      className: '',
      x: 126,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1234567',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fill: '#ffffff',
        stroke: '#000000',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4ebb7ea1-a090-475f-946f-9c1cc8012a44',
      data: ''
    },
    {
      id: '7e84205d-6413-47d8-8366-d3192d14f77c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'text_bg_med_2',
      parent: '6a00832d-c342-49ac-8aaa-9e8201e2bf1a',
      data: ''
    },
    {
      id: 'e44ab3af-8426-4c8a-920c-a5d4fc5d048d',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Boosters',
      localize: true,
      maxWidth: 147,
      maxHeight: 47,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#271611',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowAngle: 1.6,
        dropShadowBlur: 0,
        dropShadowColor: '#251705',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6a00832d-c342-49ac-8aaa-9e8201e2bf1a',
      data: ''
    },
    {
      id: '43ac3788-5b0c-41f1-a660-d0930b6a80c1',
      type: 'Sprite',
      name: 'boostersOpened',
      nameSpace: '',
      className: '',
      x: 0,
      y: -122,
      anchor: {
        x: 0.45,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_toolbox_open',
      parent: '6a00832d-c342-49ac-8aaa-9e8201e2bf1a',
      data: ''
    },
    {
      id: '8818d104-d2bb-4fec-9bf1-248855531b7b',
      type: 'Sprite',
      name: 'boostersButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: -122,
      anchor: {
        x: 0.45,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'hud_toolbox',
      parent: '6a00832d-c342-49ac-8aaa-9e8201e2bf1a',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class LevelHudLayout {
  static raw = raw;
  root: PIXI.Container
  leftTop: PIXI.Container
  coinBarContainer: PIXI.Container
  rightTop: PIXI.Container
  leftBottom: PIXI.Container
  settingsButton: PIXI.Sprite
  centerBottom: PIXI.Container
  endLevelButton: PIXI.Sprite
  jokerContainer: PIXI.Container
  jokerText: PIXI.Text
  jokerCoin: PIXI.Sprite
  jokerButton: PIXI.Sprite
  undoContainer: PIXI.Container
  undoText: PIXI.Text
  undoCoin: PIXI.Sprite
  undoButton: PIXI.Sprite
  extraCardsButton: PIXI.Sprite
  extraCardsText: PIXI.Text
  extraCardsCoin: PIXI.Sprite
  goldBarContainer: PIXI.Container
  goldBarProgress: PIXI.Sprite
  goldBarInfoText: PIXI.Text
  goldBarText: PIXI.Text
  centerTop: PIXI.Container
  scoreBarContainer: PIXI.Container
  scoreBarProgress: PIXI.Sprite
  scoreDevText: PIXI.Text
  rightBottom: PIXI.Container
  boostersContainer: PIXI.Container
  boostersOpened: PIXI.Sprite
  boostersButton: PIXI.Sprite
  overlay: PIXI.Graphics
  scoreBarStars: (PIXI.Sprite)[]

  constructor() {
    populate(this, raw);
  }
}
